module.exports = __webpack_public_path__ + "static/media/payroll-perks.a95ba251.svg";